// extracted by mini-css-extract-plugin
module.exports = {"password":"NewPasswordForm_password__3Lvlz","submitButton":"NewPasswordForm_submitButton__Lp_qn"};